<template>
  <div class="p-3 pt-md-4 pt-5 text-white">
    <v-container fluid>
      <Stepper
        v-model="activeTab"
        :active-tab="activeTab"
        :questions="questions"
      />
      <v-row>
        <v-col
          md="3"
          class="pl-md-0"
        >
          <MarkerComponent
            v-model="activeTab"
            :active-tab="activeTab"
            :challenge="challenge"
          />
        </v-col>

        <v-col
          md="6"
          class="mt-4 mt-md-0"
        >
          <div class="rounded-lg bg-dark-modal pb-4">
            <div
              v-for="(question, key) in questions"
              v-show="activeTab === key"
              :key="key"
            >
              <div class="border-bottom border-secondary font-weight-bold h5 p-3">
                Questão {{ question.key + 1 }}
              </div>
              <div
                :style="`height: ${defaultModalHeight}; overflow-y: auto; overflow-x:hidden`"
                class="p-3 bg-white"
              >
                <QuestionContent :question="currentQuestion" />
              </div>
            </div>
          </div>
        </v-col>

        <v-col
          md="3"
          class="pr-md-0"
        >
          <div class="rounded-lg bg-dark-modal">
            <div class="border-bottom border-secondary font-weight-bold h5 p-3 mt-4 mt-md-0">
              Alternativas
            </div>

            <QuestionChoiceSelector
              :question="currentQuestion"
              :disabled="disabled"
              @click="answerQuestion"
            />

            <div
              id="prev-next-container"
              class="d-flex justify-content-between p-3 flex-wrap"
            >
              <v-btn
                rounded
                color="challenge"
                class="text-black my-1"
                @click="decrease"
              >
                <i class="fas fa-chevron-left align-middle" />
                <span class="align-middle">Anterior</span>
              </v-btn>
              <v-btn
                rounded
                color="challenge"
                class="text-black my-1"
                @click="increase"
              >
                <span class="align-middle">Próximo</span>
                <i class="fas fa-chevron-right align-middle" />
              </v-btn>
            </div>
          </div>

          <QuestionResult
            v-if="challenge.finished_at"
            :question="currentQuestion"
          />
          <TimeCounter />

          <v-btn
            v-if="!disabled"
            rounded
            color="challenge"
            class="text-black w-100 mt-4"
            @click="SET_IS_FINISH_CURRENT_CHALLENGE()"
          >
            Finalizar desafio
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import HasClearRouter from '@/common/mixins/HasClearRouter.js'
import { defaultModalHeight } from '@/constants/general.js'
import MarkerComponent from '@/common/components/challenge/MarkerComponent'
import QuestionContent from '@/common/components/challenge/QuestionContent'
import QuestionChoiceSelector from '@/common/components/challenge/QuestionChoiceSelector'
import QuestionResult from "@/common/components/challenge/QuestionResult.vue"
import Stepper from '@/common/components/challenge/Stepper.vue'
import { mapMutations, mapActions, mapGetters } from 'vuex'
import TimeCounter from "./TimeCounter.vue"

export default {
  components: {
    MarkerComponent,
    Stepper,
    QuestionContent,
    QuestionResult,
    TimeCounter,
    QuestionChoiceSelector,
  },
  mixins: [HasClearRouter],
  data() {
    return {
      activeTab: 0,
      defaultModalHeight,
      request_time: 0,
      slow_time: 15,
    }
  },
  computed: {
    ...mapGetters(['selectedCycle','challenge']),
    disabled() {
      return !this.challenge.can_finish
    },
    questions() {
      return this.challenge.questions
    },
    canStart() {
      return  !this.challenge.finished_at && this.$moment(this.challenge.unavailable_at).isAfter(this.$moment())
    },
    currentQuestion() {
      return this.questions[this.activeTab]
    },
  },
  methods: {
    ...mapActions(['answerChallenge','load']),
    ...mapMutations(['SET_IS_FINISH_CURRENT_CHALLENGE']),
    increase() {
      this.activeTab += this.activeTab < this.questions.length - 1 ? 1 : 0
    },
    decrease() {
      this.activeTab -= this.activeTab > 0 ? 1 : 0
    },
    answerQuestion(alternative){
      this.load({ isLoading: true, message: 'Respondendo...'})
      let nIntervId
        
        nIntervId = setInterval(() => {
          this.request_time+=1
          if(this.request_time >= this.slow_time){
            this.load({
              isLoading: true, 
              message: 'O processo está demorando mais do que o normal. Por favor, aguarde.'
            })
          }
        }, 1000)

      this.answerChallenge({
          id: this.challenge.id,
          data: {
            user_answer: alternative,
            question_id: this.currentQuestion.id
          }
      })
      .finally(()=> {
        this.load(false)
        clearInterval(nIntervId)
        this.request_time = 0
      })
    }
  }
}
</script>
<style scoped>

@media screen and (max-width: 1256px) {
  #prev-next-container button{
    width: 100%;
  }
}

@media screen and (max-width: 766px) {
  #prev-next-container button{
    width: 50%;
  }
}
</style>
